import { useCallback, useState } from "react";
import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import { ContentCard } from "cerulean";
import { useDashboardLayoutRedesignEnabled } from "byzantine";
import { CardOffersActivationModal } from "../../CardLinkedOffers/ActivationModal";
import useCardLinkedOffersFeature from "../../CardLinkedOffers/hooks";
import styles from "./CardOffers.module.scss";

const CardOffersUnenrolled = () => {
  const { l10n } = useLocalization();
  const isDashboardLayoutRedesignEnabled = useDashboardLayoutRedesignEnabled();
  const isCardLinkedOffersEnabled = useCardLinkedOffersFeature();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleActivateRewards = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  // Don't render if feature flag is disabled
  if (!isCardLinkedOffersEnabled) {
    return null;
  }

  const ContentContainer = isDashboardLayoutRedesignEnabled
    ? "div"
    : ContentCard;

  return (
    <div>
      <ContentContainer kind="elevated">
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.logoContainer}>
              <div className={styles.logo}>
                <span className="narmi-icon-credit-card" />
              </div>
            </div>
          </div>

          <div className={styles.content}>
            <div className={`fontSize--m fontWeight--bold ${styles.title}`}>
              {l10n.getString(
                "card-offers-dashboard-title",
                null,
                "Make spending more rewarding"
              )}
            </div>
            <div
              className={`fontSize--xs fontWeight--normal ${styles.description}`}
            >
              {l10n.getString(
                "card-offers-dashboard-description",
                null,
                "Turn everyday purchases into rewards. Activate cash back on your card and start earning money back on dining, groceries, gas, and more."
              )}
            </div>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <Button
            label={l10n.getString(
              "card-offers-activate-button",
              null,
              "Activate cash back rewards"
            )}
            testId="activate-offers"
            onClick={handleActivateRewards}
          />
        </div>
      </ContentContainer>

      <CardOffersActivationModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        testId="card-offers-activation-modal"
      />
    </div>
  );
};

export default CardOffersUnenrolled;
